<template>
    <div :class="container.containerClasses" :style="container.containerStyles">
        <template v-for="option in options" :key="option.configuracoesDeCampo.id">
            <div v-e2e="'filter-box-container'" :class="option?.containerOptions?.containerClasses" :style="option?.containerOptions?.containerStyles">
                <TrfFormFieldFacade
                    :type="option.configuracoesDeCampo.type"
                    :configuration="option.configuracoesDeInput"
                    :ref="option.configuracoesDeCampo.id"
                    @value-change="(value, isClear) => updateQuery(value, option, isClear)"
                    @clear="limparCampo"
                    @send-value="setValue"
                ></TrfFormFieldFacade>
            </div>
        </template>
        <div v-if="advancedOptions.length > 0" class="column is-block has-text-right">
            <a v-e2e="'button-togle-filter'" @click="toggleAdvancedOptions" title="Filtro avançado">Filtro avançado</a>
        </div>
    </div>
    <template v-if="advancedOptions.length > 0">
        <div class="advanced-container mt-5" :class="{'is-active': this.isAdvancedContainerActive}">
            <div v-e2e="'filter-box-advanced-container'" :class="advancedContainer.containerClasses" :style="advancedContainer.containerStyles">
                <template v-for="option in advancedOptions" :key="option.configuracoesDeCampo.id">
                    <div :class="option?.containerOptions?.containerClasses" :style="option?.containerOptions?.containerStyles">
                        <TrfFormFieldFacade
                            :type="option.configuracoesDeCampo.type"
                            :configuration="option.configuracoesDeInput"
                            :ref="option.configuracoesDeCampo.id"
                            @value-change="(value, isClear) => updateQuery(value, option, isClear)"
                            @clear="limparCampo"
                            @send-value="setValue"
                        ></TrfFormFieldFacade>
                    </div>
                </template>
            </div>
        </div>
    </template>
</template>
  
  <script>
import { defineAsyncComponent } from 'vue';
import { ConfigFiltro } from './models/configFiltro.model';

  export default {
    name: "TrfFilter",
    emits: ['update:query-string', 'error:invalid-input'],
    components: {
        TrfFormFieldFacade: defineAsyncComponent(() => import('./components/formFieldFacade.vue'))
    },
    props: {
        configuration: {
            type: Object,
            required: true,
            default: new ConfigFiltro()
        }
    },
    data() {
      return {
        queryString: {},
        isAdvancedContainerActive: false
      };
    },
    computed: {
        container() {
            if (!this.configuration?.containerOptions) return {}

            return this.configuration?.containerOptions
        },
        advancedContainer() {
            if (!this.configuration?.advancedContainerOptions) return {}

            return this.configuration?.advancedContainerOptions
        },
        options() {
            if (!this.configuration?.options) return []

            return this.configuration?.options
        },
        advancedOptions() {
            if (!this.configuration?.advancedOptions) return []

            return this.configuration?.advancedOptions
        },
    },
    methods: {
        updateQuery(value, option, isClear = false) {
            if (!isClear && value === null) return;
            if (!option?.configuracoesDeCampo?.key) return;
            if (!isClear && option.configuracoesDeCampo.formatter) {
                value = option.configuracoesDeCampo.formatter(value)
            }
            if (!isClear && !!option.configuracoesDeInput.validationFn && !option.configuracoesDeInput.validationFn(value)) {
                this.$emit("error:invalid-input", {
                    error: "Valor preenchido não é valido",
                    type: option.configuracoesDeCampo.type,
                    value: value
                })
                this.$emit('update:query-string', this.queryString)
                return
            }
            this.queryString[option?.configuracoesDeCampo?.key] = value;
            this.$emit('update:query-string', this.queryString)
        },
        toggleAdvancedOptions() {
            this.isAdvancedContainerActive = !this.isAdvancedContainerActive
        },
        limparCampo(valor) {
            if (!valor || !this.$refs[valor]?.length > 0) return
            this.$refs[valor][0].limparCampo()
        },
        setValue(value, target) {
            if (!target || !this.$refs[target].length > 0) return
            this.$refs[target][0].replaceValue(value)
        }
    },
    mounted() {
    }, 
  };
  </script>
  
  <style lang="scss" scoped>
    .advanced-container {
        display: none;
        padding: 12px;
        .is-advanced-filter-box {
            padding: 19px;
            margin-bottom: 20px;
            background-color: #f5f5f5;
            border: 1px solid #e3e3e3;
            border-radius: 4px;
            min-height: 20px;
        }
        &.is-active {
            display: block;
        }
    }
  </style>
  